import { useCallback, useMemo } from "react"

export default function useLiveChatUserId(navigation, route) {
    const liveChatUserId = route?.params?.liveChatUserId === "null" ||
    route?.params?.liveChatUserId === null ||
    route?.params?.liveChatUserId === undefined
    ? null
    : route?.params?.liveChatUserId

    const setLiveChatUserId = useCallback(
        (userId) => {
            navigation?.setParams({
                ...route?.params,
                liveChatUserId: userId,
            })
        },
        [navigation, route?.params]
    )

    return { liveChatUserId, setLiveChatUserId }
}
